<template>
    <p style="font-size:48px;text-align: center;color:red;margin-top: 30%;">404</p>
</template>
<script>
export default{
    name:'V404'
}
</script>